import { SetStateAction } from 'react';
import { connect } from 'react-redux';
import { setSearchSectionPage } from 'redux/modules/search';
import { RootState } from 'redux/modules/types';
import {
  SEARCH_VISUALS_PER_PAGE_DETAIL,
  SEARCH_VISUALS_PER_PAGE_MASTER,
} from 'utils/config';
import { getPageCount } from 'utils/getPageCount';
import { OwnProps } from './types';

const mapStateToProps = (state: RootState, { isDetail }: OwnProps) => ({
  available: state.search.available.visuals,
  count: state.search.count.visuals,
  items: state.search.ids.visuals
    .map((id) => state.search.byId.visuals[id])
    .filter((it): it is NonNullable<typeof it> => !!it),
  loading: state.search.loading.visuals,
  page: state.search.page.visuals,
  pageCount: getPageCount(
    state.search.count.visuals,
    isDetail ? SEARCH_VISUALS_PER_PAGE_DETAIL : SEARCH_VISUALS_PER_PAGE_MASTER,
  ),
});

const mapDispatchToProps = {
  setPage: (page: SetStateAction<number>) =>
    setSearchSectionPage({
      page,
      section: 'visuals',
    }),
};

export default connect(mapStateToProps, mapDispatchToProps);

export type ConnectedProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;
